export default __webpack_public_path__ + "static/media/tombchainmini.efce5ca5.svg";